import { FC, ReactNode, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { priceImprovementBlotterPreferenceStateLoaded } from 'state/blotters/priceImprovement/priceImprovementBlotter.action';
import { priceImprovementBlotter } from 'state/selectors';

import { emptyBlotterPreferences } from '../../shared/Blotter/Grid/blotter.model';
import { BlotterPreferencesLoadingErrorModal } from '../blotterPreferencesLoadingErrorModal';

export const PreferencesLoadingErrorModal: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const dispatch = useDispatch();

  const hasLoadingError = useSelector(priceImprovementBlotter.areBlotterPreferencesInError);
  const onContinueAndDefault = useCallback(
    () => dispatch(priceImprovementBlotterPreferenceStateLoaded(emptyBlotterPreferences)),
    [dispatch],
  );

  return (
    <BlotterPreferencesLoadingErrorModal hasLoadingError={hasLoadingError} onContinueAndDefault={onContinueAndDefault}>
      {children}
    </BlotterPreferencesLoadingErrorModal>
  );
};
